import {
  SELECTABLE_MODELS,
  ReasoningEffortSchema,
  type ReasoningEffortLevel,
  type SelectableModelSlug,
} from '@hector/shared-types';

export interface CaseDiscoveryModelPreference {
  model: SelectableModelSlug;
  reasoningEffort?: ReasoningEffortLevel;
}

const MODEL_KEY = 'hector_sa_case_discovery_chat_model';
const REASONING_KEY = 'hector_sa_case_discovery_chat_reasoning';

export function getCaseDiscoveryModelPreference(): CaseDiscoveryModelPreference | null {
  try {
    const rawModel = localStorage.getItem(MODEL_KEY);
    if (!rawModel) return null;

    const found = SELECTABLE_MODELS.find((model) => model.slug === rawModel);
    if (!found || !found.chat) return null;

    const rawReasoning = localStorage.getItem(REASONING_KEY);
    const parsedReasoning = rawReasoning ? ReasoningEffortSchema.safeParse(rawReasoning) : null;
    const reasoningEffort = found.reasoning && parsedReasoning?.success
      ? parsedReasoning.data
      : undefined;

    return {
      model: found.slug as SelectableModelSlug,
      ...(reasoningEffort !== undefined ? { reasoningEffort } : {}),
    };
  } catch {
    return null;
  }
}

export function setCaseDiscoveryModelPreference(preference: CaseDiscoveryModelPreference): void {
  try {
    localStorage.setItem(MODEL_KEY, preference.model);
    if (preference.reasoningEffort !== undefined) {
      localStorage.setItem(REASONING_KEY, preference.reasoningEffort);
    } else {
      localStorage.removeItem(REASONING_KEY);
    }
  } catch {
    // localStorage can be unavailable in restricted browser contexts; default prod chain remains.
  }
}

export function clearCaseDiscoveryModelPreference(): void {
  try {
    localStorage.removeItem(MODEL_KEY);
    localStorage.removeItem(REASONING_KEY);
  } catch {
    // localStorage can be unavailable in restricted browser contexts; no override is stored.
  }
}
